import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import Axios, { AxiosResponse } from "axios";
import config from "../config";
import CoreComponent from "../pages/CoreComponent";
import axios from "axios";
import Async from 'react-select/async';
import { arrayToFormData } from "../utils/functions";
import { toast } from "react-toastify";

interface IProps extends WithTranslation {
    isOpen: boolean,
    handleModal: any,
    models: any[],
    date_from: string,
    to_date: string
}

interface IState {
    isLoading: boolean,
    matrix: any[],
    holders: { full_name: string, user_id: number }[],
    uz_holders: { full_name: string, user_id: number }[],
    setting: any
}

class MoveModal extends CoreComponent<IProps, IState> {
    state: IState = {
        isLoading: true,
        matrix: [],
        holders: [],
        uz_holders: [],
        setting: null
    }

    async componentDidMount() {
        let res = await Axios.get(`${config.api}/auth/setting`);

        if (res.data) {
            this.setState({
                setting: res.data
            });
        }
    }

    async loadHolders() {
        let response: AxiosResponse = await axios.get(`${config.api}/user/list`);
        let response_uz: AxiosResponse = await axios.get(`https://uz.rizanova.site/api/user/list`);

        if (!this.isUnmounted) {
            this.setState({
                holders: response.data,
                uz_holders: response_uz.data,
                isLoading: false
            });
        }
    }

    async componentWillMount() {
        await this.loadHolders();
    }

    componentWillReceiveProps(nextProps: any) {

        if (nextProps.isOpen) {
            let matrix = [];

            for (let i = 0; i < nextProps.models.length; i++) {
                let uz_holder: any = this.state.uz_holders.find((holder) => holder.full_name.trim() == nextProps.models[i].full_name.trim());

                matrix.push([
                    parseFloat(nextProps.models[i].balance > 0 ? nextProps.models[i].balance : 0), Number.parseFloat(this.state.setting?.course.toString()), nextProps.models[i].full_name.trim(), this.state.setting?.comment + " " + nextProps.to_date, uz_holder ? uz_holder.user_id : ""
                ]);
            }

            this.setState({
                matrix
            }, () => {
                console.log(this.state.matrix);

            });
        }
    }

    loadOptions = (full_name: string) => {
        return (inputValue: any, callback: any) => {
            callback(inputValue ? this.state.holders.filter((holder) => holder.full_name.toLowerCase().indexOf(inputValue.toLowerCase()) > -1).map((holder) => {
                return { value: holder.user_id, label: holder.full_name };
            }) : this.state.holders.filter((holder) => holder.full_name.toLowerCase().indexOf(full_name.toLowerCase()) > -1).map((holder) => {
                return { value: holder.user_id, label: holder.full_name };
            }));
        };
    };

    loadOptions2 = (full_name: string) => {
        return (inputValue: any, callback: any) => {
            callback(inputValue ? this.state.uz_holders.filter((holder) => holder.full_name.toLowerCase().indexOf(inputValue.toLowerCase()) > -1).map((holder) => {
                return { value: holder.user_id, label: holder.full_name };
            }) : this.state.uz_holders.filter((holder) => holder.full_name.toLowerCase().indexOf(full_name.toLowerCase()) > -1).map((holder) => {
                return { value: holder.user_id, label: holder.full_name };
            }));
        };
    };

    async move() {
        this.setState({
            isLoading: true
        }, async () => {
            let res = await axios.post(`${config.api}/transactions/move`, arrayToFormData({
                matrix: this.state.matrix
            }));

            this.setState({
                isLoading: false
            });

            if (res.data.status == "success") {
                toast(("Партнер сохранён."), { type: "success" });
                this.props.handleModal();
                await this.loadHolders();
            } else {
                toast(res.data.message, { type: "error" });
                this.props.handleModal();
            }
        });

    }

    render() {
        return (
            <div className={"popup " + (this.props.isOpen ? "d-flex" : "")}>
                <div className="popup__content" style={{ height: "80vh", width: "1300px", overflowY: 'scroll' }}>
                    <img onClick={async () => {
                        this.props.handleModal();
                        await this.loadHolders();
                    }} src="img/Icon ionic-md-add.png" alt="" className="popup-del" />
                    <h1 className="popup__title">Перенести доход партнеров на UZ CRM</h1>
                    <div className="crm-list">
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: "200px" }}>Партнер</th>
                                    <th style={{ width: "200px" }}>Партнер на UZ CRM</th>
                                    <th>Сумма</th>
                                    <th>Курс</th>
                                    <th>Комментария</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.isLoading && <tr><td colSpan={10}>Загрузка...</td></tr>}
                                {this.state.matrix.map((array, i: number) => {
                                    let holder = this.state.holders.find((holder) => holder.full_name.trim() == array[2]);
                                    let uz_holder = this.state.uz_holders.find((holder) => holder.user_id == array[4]);

                                    return <tr key={i}>
                                        <td className="p-0 border" style={{ width: "200px" }}>
                                            <Async
                                                className="w-99"
                                                cacheOptions
                                                value={{ label: holder?.full_name, value: holder?.user_id }}
                                                loadOptions={this.loadOptions(array[2])}
                                                defaultOptions
                                                onChange={(newValue) => {
                                                    this.setState({
                                                        matrix: this.state.matrix.map((array, ii) => {
                                                            return i != ii ? [...array] : [parseFloat(array[0]), parseFloat(array[1]), newValue.label, array[3], array[4]];
                                                        })
                                                    });

                                                    return newValue;
                                                }}
                                            />
                                        </td>
                                        <td className="p-0 border" style={{ width: "200px" }}>
                                            <Async
                                                className="w-99"
                                                cacheOptions
                                                defaultValue={uz_holder ? { label: uz_holder?.full_name, value: uz_holder?.user_id } : null}
                                                placeholder={"Добавить новый"}
                                                loadOptions={this.loadOptions2(array[2])}
                                                defaultOptions
                                                onChange={(newValue) => {
                                                    this.setState({
                                                        matrix: this.state.matrix.map((array, ii) => {
                                                            return i != ii ? [...array] : [parseFloat(array[0]), parseFloat(array[1]), array[2], array[3], (newValue.value)];
                                                        })
                                                    });

                                                    return newValue;
                                                }}
                                            />
                                        </td>
                                        <td className="p-0 border"><input value={array[0]} className="w-99 p-2 bg-white" onChange={(e) => {
                                            this.setState({
                                                matrix: this.state.matrix.map((array, ii) => {
                                                    return i != ii ? [...array] : [parseFloat(e.target.value), parseFloat(array[1]), array[2], array[3], array[4]];
                                                })
                                            })
                                        }} /></td>
                                        <td className="p-0 border"><input value={array[1]} className="w-99 p-2 bg-white" onChange={(e) => {
                                            this.setState({
                                                matrix: this.state.matrix.map((array, ii) => {
                                                    return i != ii ? [...array] : [parseFloat(array[0]), parseFloat(e.target.value), array[2], array[3], array[4]];
                                                })
                                            })
                                        }} /></td>

                                        <td className="p-0 border"><input value={array[3]} className="w-99 p-2 bg-white" onChange={(e) => {
                                            this.setState({
                                                matrix: this.state.matrix.map((array, ii) => {
                                                    return i != ii ? [...array] : [parseFloat(array[0]), parseFloat(array[1]), array[2], e.target.value, array[4]];
                                                })
                                            })
                                        }} /></td>
                                    </tr>;
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className="crm-holders__buttons mt-4 text-right">
                        <a className="crm-button" role="button" onClick={() => {
                            this.move();
                        }}>{this.state.isLoading ? (
                            <i className="fa fa-spinner fa-2x rotating "></i>
                        ) : ("Перевести")}</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(MoveModal);